/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RelinkPreviewCounts } from './relinkPreviewCounts';

export interface JobLinkResponse {
  id: string;
  job_id: string;
  connection_id: string;
  remote_job_id: string;
  stage_sync_tier: string;
  link_origin: string;
  sync_enabled: boolean;
  resumed?: boolean;
  counts?: RelinkPreviewCounts | null;
}
